<template>
  <div>
    <title>退款管理</title>
    <section class="mainPart">
      <RefundInfo :key="refreshnum" :refundType="0" :enterWay="1" eleType="发货"></RefundInfo>
    </section>
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
export default {
  name: "RefundManagement",
  data() {
    return {
      refreshnum: 1,
      refundType: 1,
      userInfo: '', // 登录信息
    };
  },
  filters: {},
  components: {
    RefundInfo: resolve =>
      require(["@/components/OrderFolder/StoreSale/RefundInfo.vue"], resolve) //退款申请组件
  },
  methods: {},
  created() {
    if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!=undefined) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfoMd'));
      this.refreshnum = this.userInfo.isopensale?1:0;
      this.refundType = this.userInfo.isopensale?1:0;
    }
  },
  watch: {
    refundType: {
      handler: function() {
        this.refreshnum++;
      }
    }
  },
  mounted() {
    
  },
  computed: {}
};
</script>

<style scoped>
@import "Css/Style.css";
.mainPart{padding: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/DeliveryFolder/RefundVerifyList.vue